import { onSubmitSellerGdm } from 'utils';
import { SellerGdmUpdateOnSubmitFunction } from './updateSellerGdm.type';

const sellerGdmUpdateOnSubmit: SellerGdmUpdateOnSubmitFunction = payload => {
  return onSubmitSellerGdm({ method: 'put', ...payload, id: payload.sellerGdm.id });
};

export default sellerGdmUpdateOnSubmit;
